export default __webpack_public_path__ + "static/media/dablogo.ccb6eb06.png";